import { Injectable, inject } from '@angular/core';
import { AppContextService } from '@drc-eca/eca-components-lib';
import { OktaTenantService } from './okta-tenant.service';

@Injectable({
  providedIn: 'root',
})
export class ProductContextService {
  private appContextService = inject(AppContextService);

  setSelectedProductCode(productCode: string | null | undefined): void {
    this.syncTenant(productCode);
    this.appContextService.setSelectedProductCode(productCode || '');
  }

  syncTenant(productCode: string | null | undefined): void {
    if (OktaTenantService.isOpaTenantEnabled() && productCode?.toUpperCase() === 'DEOCS') {
      sessionStorage.setItem('useTenant', 'opa');
    } else {
      sessionStorage.removeItem('useTenant');
    }
  }
}
